import { create } from "zustand";

export const FONTS = ["inter", "manrope", "system"] as const;
export type Font = (typeof FONTS)[number];

const FONT_COOKIE = "font";

type FontState = {
  font: Font;
  setFont: (font: Font) => void;
  resetFont: () => void;
};

const initial = (): Font => {
  if (typeof document === "undefined") return "inter";
  const cookie = document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${FONT_COOKIE}=`))
    ?.split("=")[1];
  if (cookie && (FONTS as readonly string[]).includes(cookie)) return cookie as Font;
  return "inter";
};

const applyFont = (font: Font) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.forEach((c) => {
    if (c.startsWith("font-")) root.classList.remove(c);
  });
  root.classList.add(`font-${font}`);
};

export const useFontStore = create<FontState>((set) => ({
  font: initial(),
  setFont: (font) => {
    if (typeof document !== "undefined") {
      document.cookie = `${FONT_COOKIE}=${font}; path=/; max-age=${60 * 60 * 24 * 365}`;
    }
    applyFont(font);
    set({ font });
  },
  resetFont: () => {
    if (typeof document !== "undefined") {
      document.cookie = `${FONT_COOKIE}=; path=/; max-age=0`;
    }
    applyFont("inter");
    set({ font: "inter" });
  },
}));

if (typeof window !== "undefined") {
  applyFont(useFontStore.getState().font);
}
